import Dialog from "../../dialog/Dialog";
import { useState, useEffect } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  STATUS_DIALOG_WIDTH,
  StatusApprovalSection,
  StatusSettingsBody,
  StatusToggleRow,
} from "../../common/StatusSettingsParts";
import { updateActivitySettings } from "./service";

function to01(v) {
  if (v === true || v === 1 || v === "1") return 1;
  return 0;
}

function toApprovalTriState(v) {
  if (v === true || v === 1 || v === "1") return 1;
  if (v === 2 || v === "2") return 2;
  return 0;
}

const ActivitySettings = ({ open, onClose, activityData, onNotify }) => {
  const queryClient = useQueryClient();

  const [status, setStatus] = useState({
    popular: to01(activityData?.popular),
    recommended: to01(activityData?.recommended),
    is_approved: toApprovalTriState(activityData?.is_approved),
    is_active:
      activityData?.is_active === undefined || activityData?.is_active === null
        ? 1
        : to01(activityData.is_active),
  });

  useEffect(() => {
    if (!open || !activityData) return;
    setStatus({
      popular: to01(activityData.popular),
      recommended: to01(activityData.recommended),
      is_approved: toApprovalTriState(activityData.is_approved),
      is_active:
        activityData.is_active === undefined || activityData.is_active === null
          ? 1
          : to01(activityData.is_active),
    });
  }, [open, activityData]);

  const handleToggle = (field) => {
    setStatus((prev) => ({ ...prev, [field]: prev[field] === 1 ? 0 : 1 }));
  };

  const updateMutation = useMutation({
    mutationFn: () => updateActivitySettings(activityData.id, status),
    onSuccess: () => {
      queryClient.invalidateQueries(["supplierActivities"]);
      onNotify?.({
        message: "Activity settings updated successfully",
        type: "success",
      });
      onClose();
    },
    onError: (error) => {
      const apiMessage = error.response?.data?.message;
      const validationErrors = error.response?.data?.errors;
      const message =
        (typeof apiMessage === "string" && apiMessage) ||
        (validationErrors &&
          Object.values(validationErrors).flat().join(", ")) ||
        error.message ||
        "Failed to update activity settings";

      onNotify?.({
        message,
        type: "error",
      });
    },
  });

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        title="Activity Status"
        width={STATUS_DIALOG_WIDTH}
        primaryButtonText="Save Changes"
        primaryButtonAction={() => updateMutation.mutate()}
        isLoading={updateMutation.isPending}
      >
        <StatusSettingsBody>
          <StatusToggleRow
            title="Popular"
            description="Show this activity as popular"
            checked={Number(status.popular) === 1}
            onChange={() => handleToggle("popular")}
          />
          <StatusToggleRow
            title="Explore World Recommended"
            description="Mark as recommended"
            checked={Number(status.recommended) === 1}
            onChange={() => handleToggle("recommended")}
          />
          <StatusApprovalSection
            value={status.is_approved}
            onChange={(value) =>
              setStatus((prev) => ({ ...prev, is_approved: value }))
            }
            description="Approve / reject this activity"
          />
          <StatusToggleRow
            title="Active"
            description="Visible to users (if approved)"
            checked={Number(status.is_active) === 1}
            onChange={() => handleToggle("is_active")}
          />
        </StatusSettingsBody>
      </Dialog>
    </>
  );
};

export default ActivitySettings;
